// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-AutoExclusions-components-StudyList-Collapser-module__collapse";
var _2 = "webpack-pages-AutoExclusions-components-StudyList-Collapser-module__collapseAnimation";
var _3 = "webpack-pages-AutoExclusions-components-StudyList-Collapser-module__wrapper";
export { _1 as "collapse", _2 as "collapseAnimation", _3 as "wrapper" }
